var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLine61 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 63,
  height: 1,
  viewBox: "0 0 63 1",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 63,
  y1: 0.5,
  y2: 0.5,
  stroke: "#0A3887"
})));
export { SvgLine61 as ReactComponent };
export default __webpack_public_path__ + "516e476e273fcdabd7613cc8d02f8fe0.svg";